import { useState } from "react";
import { motion } from "framer-motion";
import { GATES, INPUTS } from "@/data/temple";
import { Eyebrow, Reveal } from "./Reveal";

export default function Matrix() {
  const [sel, setSel] = useState("energy");
  const lit = GATES.map((g) => g.keys.includes(sel));
  const count = lit.filter(Boolean).length;
  const label = INPUTS.find(([k]) => k === sel)?.[1];

  return (
    <section id="matrix" data-testid="matrix-section" className="relative max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-40">
      <div className="grid lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-5">
          <Eyebrow n="III">The Orgasm Matrix</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-8 leading-[1.05]">
            Inputs in. <em className="text-[#D9B47A]">Ecstasy</em> out.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#A8998C] leading-relaxed">
            The map beneath the gates. Inputs are the pathways through which sensation, attention or energy enter the
            system. Outputs are the ways pleasure manifests and spreads. This language turns confusion into curiosity.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-7">
          <p className="font-tt-mono text-[12px] uppercase tracking-[0.25em] text-[#A8998C]">Choose an input</p>
          <div className="mt-5 flex flex-wrap gap-2.5">
            {INPUTS.map(([k, l]) => (
              <button
                key={k}
                data-testid={`matrix-input-${k}`}
                onClick={() => setSel(k)}
                className={`rounded-full border px-4 py-2 text-sm transition-colors duration-300 ${
                  sel === k ? "bg-[#C2414F] border-[#C2414F] text-[#F2E8DF]" : "border-[#D9B47A]/30 text-[#CFC2B6] hover:border-[#D9B47A]"
                }`}
              >
                {l}
              </button>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-7 sm:grid-cols-[repeat(13,minmax(0,1fr))] gap-2 sm:gap-3">
            {GATES.map((g, i) => (
              <motion.div
                key={g.name}
                title={g.name}
                data-testid={`matrix-gate-${i + 1}`}
                animate={{
                  backgroundColor: lit[i] ? "#D9B47A" : "rgba(217,180,122,0)",
                  color: lit[i] ? "#0A0706" : "#8F8176",
                  scale: lit[i] ? 1 : 0.9,
                }}
                transition={{ duration: 0.45, delay: i * 0.025 }}
                className="aspect-square rounded-full border border-[#D9B47A]/40 flex items-center justify-center font-tt-mono text-[12px]"
              >
                {String(i + 1).padStart(2, "0")}
              </motion.div>
            ))}
          </div>

          <div className="mt-10 border-t border-[#D9B47A]/20 pt-6 flex flex-wrap items-baseline gap-x-6 gap-y-2">
            <span data-testid="matrix-count" className="font-display text-6xl text-[#D9B47A]">{count}</span>
            <span className="text-[#CFC2B6]">
              of 13 gates open through <em className="font-display text-xl text-[#F2E8DF]">{label}</em>
            </span>
          </div>
          <p className="mt-3 text-sm text-[#A8998C]">
            {GATES.filter((_, i) => lit[i]).map((g) => g.name).join(" · ")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
